'use client';

import React from 'react';
import { useRouter } from 'next/navigation';

/**
 * 404 page. Minimal deps (no AppIcon) so it loads when chunks are broken.
 */
export default function NotFound() {
  const router = useRouter();

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        backgroundColor: '#eeeced',
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: 400 }}>
        <h1 style={{ fontSize: '6rem', fontWeight: 700, color: '#236434', opacity: 0.2, margin: 0 }}>
          404
        </h1>
        <h2 style={{ fontSize: '1.5rem', fontWeight: 600, color: '#111827', marginTop: 16, marginBottom: 8 }}>
          Page not found
        </h2>
        <p style={{ color: '#64748b', fontSize: 14, marginBottom: 24 }}>
          The page you&apos;re looking for doesn&apos;t exist.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            type="button"
            onClick={() => router.back()}
            style={{
              padding: '12px 24px',
              borderRadius: 8,
              border: '1px solid #236434',
              backgroundColor: 'transparent',
              color: '#236434',
              fontWeight: 600,
              fontSize: 14,
              cursor: 'pointer',
            }}
          >
            Go back
          </button>
          <button
            type="button"
            onClick={() => router.push('/')}
            style={{
              padding: '12px 24px',
              borderRadius: 8,
              border: 'none',
              backgroundColor: '#236434',
              color: 'white',
              fontWeight: 600,
              fontSize: 14,
              cursor: 'pointer',
            }}
          >
            Go home
          </button>
        </div>
      </div>
    </div>
  );
}
